export const PMP_EMAIL_DOMAIN = "@patientmpower.com";
export const AEROGEN_EMAIL_DOMAIN = "@aerogen.com";

// patientMpower's public support page — where the Intercom launcher lives for
// anyone without a portal session (Intercom itself only boots after login).
export const PMP_SUPPORT_URL = "https://patientmpower.com/support/";
